export default "__VITE_ASSET__CRaCW9FS__"